import './App.css';
import { Suspense, useEffect } from 'react';
import { CasaSubscription } from '../views/CasaSubscription';
import AppRoutes from '../routes/AppRoutes';
import ErrorScreen from '../views/ErrorScreen';
import { useAppBootstrap } from './hooks/useAppBootstrap';
import { useAppInitialization } from './hooks/useAppInitialization';
import { useQueryState } from './hooks/useQueryState';

// TEMPORARY — reset-preferences debug button. Remove this block (and the
// usePreferences import above) once done testing.

const App = () => {
  // Hide initial loader
  useEffect(() => {
    const loader = document.getElementById('initial-casa-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  }, []);

  useAppBootstrap();
  const { hasError, isLoading, onReloadClicked } = useAppInitialization();
  const { dashboardConfig } = useQueryState();

  if (hasError) {
    return <ErrorScreen onReloadClicked={onReloadClicked} />;
  }

  if (isLoading) {
    return <></>;
  }

  const isDashboardEnabled = dashboardConfig?.mobileHomeBuilderEnabled;
  const isCasaWebEnabled = dashboardConfig?.casaWebEnabled;

  return (
    <div className="App">
      <Suspense fallback={null}>
        {isDashboardEnabled || isCasaWebEnabled ? <AppRoutes /> : <CasaSubscription />}
      </Suspense>
    </div>
  );
};

export default App;
